import { createContext, useContext } from "react";
import { MaintenanceForwardingData } from "../../types/forwardings/maintenanceForwarding.type";
import { MaintenanceForwardingsDirectiveEntryKlass } from "../../types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { MaintenanceForwardingDirectiveEntryMap } from "../../types/forwardings/directiveEntries/directiveEntry.type";

export const ForwardingTabContext = createContext<{
  forwarding: MaintenanceForwardingData<
    MaintenanceForwardingDirectiveEntryMap[MaintenanceForwardingsDirectiveEntryKlass]
  > | undefined;
  forwardingUpdatedAt: number;
  directiveEntryKlass: MaintenanceForwardingsDirectiveEntryKlass | undefined;
}>({
  forwarding: undefined,
  forwardingUpdatedAt: 0,
  directiveEntryKlass: undefined,
});

export const useForwardingTabContext = <
  DirectiveEntry extends MaintenanceForwardingsDirectiveEntryKlass
>() => useContext(ForwardingTabContext) as {
  forwarding: MaintenanceForwardingData<
    MaintenanceForwardingDirectiveEntryMap[DirectiveEntry]
  >;
  forwardingUpdatedAt: number;
  directiveEntryKlass: DirectiveEntry;
};
